import { createSelector } from 'reselect';

export const sharingSettingsReducerSelector = ({ SharingSettingsReducer }) =>
  SharingSettingsReducer;

export const emailAddressSelector = createSelector(
  sharingSettingsReducerSelector,
  state => state.emailAddress,
);

export const userErrorsSelector = createSelector(
  sharingSettingsReducerSelector,
  state => state.userErrors,
);

export const canChangeOwnerSelector = createSelector(
  sharingSettingsReducerSelector,
  state => state.canChangeOwner,
);

export const canShareConsumersSelector = createSelector(
  sharingSettingsReducerSelector,
  state => state.canShareConsumers,
);

export const clientRelationshipsSelector = createSelector(
  sharingSettingsReducerSelector,
  state => state.clientRelationships,
);

export const serverAdviserArraySelector = createSelector(
  sharingSettingsReducerSelector,
  state => state.serverClientRelationships,
);

export const adviserIDsSelector = createSelector(clientRelationshipsSelector, clientRelationships =>
  clientRelationships.map(({ AdviserId }) => AdviserId),
);

export const advisersSelector = createSelector(
  sharingSettingsReducerSelector,
  state => state.advisers,
);

export const isLoadingAdvisersInTheSameOrgSelector = createSelector(
  sharingSettingsReducerSelector,
  state => state.advisersInTheSameOrgInFlightRequests > 0,
);
